/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Transition_TitleInputs */

const cs_viewings_transition_title = /** @type {(inputs: Viewings_Transition_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna stavu prohlídky`)
};

const en_viewings_transition_title = /** @type {(inputs: Viewings_Transition_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update viewing status`)
};

/**
* | output |
* | --- |
* | "Update viewing status" |
*
* @param {Viewings_Transition_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_transition_title = /** @type {((inputs?: Viewings_Transition_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Transition_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_transition_title(inputs)
	return cs_viewings_transition_title(inputs)
});